import React, { useState, Component } from 'react';
import { motion } from 'framer-motion';
import { Send, MessageCircle } from 'lucide-react';
import { Input, TextArea, Select } from './ui/Input';
import { Button } from './ui/Button';
export function ContactForm() {
  const [formData, setFormData] = useState({
    name: '',
    requirement: 'Web Design',
    phone: '',
    email: '',
    message: ''
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    setIsSubmitting(true);
    // Format message for WhatsApp
    const text = `*New Project Inquiry*\n\n*Name:* ${formData.name}\n*Requirement:* ${formData.requirement}\n*Phone:* ${formData.phone}\n*Email:* ${formData.email}\n*Message:* ${formData.message || 'No additional details'}`;
    const encodedText = encodeURIComponent(text);
    const whatsappUrl = `https://wa.me/923112148225?text=${encodedText}`;
    // Simulate loading for UX
    setTimeout(() => {
      window.open(whatsappUrl, '_blank');
      setIsSubmitting(false);
      // Optional: Reset form
      // setFormData({ name: '', requirement: 'Web Design', phone: '', email: '', message: '' })
    }, 1000);
  };
  return <motion.div initial={{
    opacity: 0,
    y: 20
  }} animate={{
    opacity: 1,
    y: 0
  }} transition={{
    duration: 0.5
  }} className="w-full max-w-2xl mx-auto bg-[#111] border border-[#222] p-8 rounded-2xl shadow-2xl" data-id="element-1">
      <div className="flex items-center justify-center mb-8" data-id="element-2">
        <div className="bg-[#0ea5e9]/10 p-3 rounded-full mr-4" data-id="element-3">
          <MessageCircle className="w-6 h-6 text-[#0ea5e9]" data-id="element-4" />
        </div>
        <h3 className="text-2xl font-bold text-white" data-id="element-5">Start Your Project</h3>
      </div>

      <form onSubmit={handleSubmit} className="space-y-6" data-id="element-6">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-7">
          <Input label="Full Name" name="name" value={formData.name} onChange={handleChange} placeholder="John Doe" required data-id="element-8" />
          <Input label="Phone Number" name="phone" type="tel" value={formData.phone} onChange={handleChange} placeholder="+44 7700 900000" required data-id="element-9" />
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-10">
          <Input label="Email Address" name="email" type="email" value={formData.email} onChange={handleChange} placeholder="john@company.com" required data-id="element-11" />
          <Select label="Requirement" name="requirement" value={formData.requirement} onChange={handleChange} options={[{
          value: 'Web Design',
          label: 'Web Design & Development'
        }, {
          value: 'Mobile App',
          label: 'Mobile App Development'
        }, {
          value: 'E-commerce',
          label: 'E-commerce Solution'
        }, {
          value: 'Digital Marketing',
          label: 'Digital Marketing'
        }, {
          value: 'Other',
          label: 'Other Inquiry'
        }]} data-id="element-12" />
        </div>

        <TextArea label="Project Details (Optional)" name="message" value={formData.message} onChange={handleChange} placeholder="Tell us a bit about your project goals..." className="min-h-[100px]" data-id="element-13" />

        <Button type="submit" className="w-full text-lg py-4" isLoading={isSubmitting} data-id="element-14">
          <Send className="w-5 h-5 mr-2" data-id="element-15" />
          Send via WhatsApp
        </Button>

        <p className="text-center text-xs text-gray-500 mt-4" data-id="element-16">
          By submitting this form, you agree to be contacted via WhatsApp
          regarding your inquiry.
        </p>
      </form>
    </motion.div>;
}